import {
  EXPORT_LEADS_ON_EMAIL,
  EXPORT_LEADS_ON_EMAIL_SUCCESS,
  EXPORT_LEADS_ON_EMAIL_ERROR,
  EXPORT_CALLS_ON_EMAIL,
  EXPORT_CALLS_ON_EMAIL_SUCCESS,
  EXPORT_CALLS_ON_EMAIL_ERROR,
  EXPORT_PROSPECTS_ON_EMAIL,
  EXPORT_PROSPECTS_ON_EMAIL_SUCCESS,
  EXPORT_PROSPECTS_ON_EMAIL_ERROR,
  EXPORT_INVOICES_ON_EMAIL,
  EXPORT_INVOICES_ON_EMAIL_SUCCESS,
  EXPORT_INVOICES_ON_EMAIL_ERROR,
  EXPORT_RECEIPTS_ON_EMAIL,
  EXPORT_RECEIPTS_ON_EMAIL_SUCCESS,
  EXPORT_RECEIPTS_ON_EMAIL_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  lead_loading: false,
  call_loading: false,
  prospect_loading: false,
  invoice_loading: false,
  receipt_loading: false
}

const ExportEmail = (state = initialState, action) => {
  switch (action.type) {
    case EXPORT_LEADS_ON_EMAIL:
      return {
        ...state,
        lead_loading: true,
        error: null,
      }
    case EXPORT_LEADS_ON_EMAIL_SUCCESS:
      return {
        ...state,
        lead_loading: false,
        error: null,
      }
    case EXPORT_CALLS_ON_EMAIL:
      return {
        ...state,
        call_loading: true,
        error: null,
      }
    case EXPORT_CALLS_ON_EMAIL_SUCCESS:
      return {
        ...state,
        call_loading: false,
        error: null,
      }
    case EXPORT_PROSPECTS_ON_EMAIL:
      return {
        ...state,
        prospect_loading: true,
        error: null,
      }
    case EXPORT_PROSPECTS_ON_EMAIL_SUCCESS:
      return {
        ...state,
        prospect_loading: false,
        error: null,
      }
    case EXPORT_INVOICES_ON_EMAIL:
      return {
        ...state,
        invoice_loading: true,
        error: null,
      }
    case EXPORT_INVOICES_ON_EMAIL_SUCCESS:
      return {
        ...state,
        invoice_loading: false,
        error: null,
      }
    case EXPORT_RECEIPTS_ON_EMAIL:
      return {
        ...state,
        receipt_loading: true,
        error: null,
      }
    case EXPORT_RECEIPTS_ON_EMAIL_SUCCESS:
      return {
        ...state,
        receipt_loading: false,
        error: null,
      }
    case EXPORT_LEADS_ON_EMAIL_ERROR:
    case EXPORT_CALLS_ON_EMAIL_ERROR:
    case EXPORT_PROSPECTS_ON_EMAIL_ERROR:
    case EXPORT_INVOICES_ON_EMAIL_ERROR:
    case EXPORT_RECEIPTS_ON_EMAIL_ERROR:
      return {
        ...state,
        lead_loading: false,
        call_loading: false,
        prospect_loading: false,
        invoice_loading: false,
        receipt_loading: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default ExportEmail;
